import { Injectable } from '@angular/core';
import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoadingService } from './loading.service';

export const IGNORE_LOADING = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    constructor(
        private loadingService: LoadingService
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.context.get(IGNORE_LOADING)) {
            return next.handle(request);
        }

        this.loadingService.setLoading(true, request.url);
        return next.handle(request)
            .pipe(
                finalize(() => {
                    this.loadingService.setLoading(false, request.url);
                })
            );
    }
}
